module.exports = __webpack_public_path__ + "static/shareIcon-3849fd03997b4aa5b0cb8f7579082421.png";